'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var YouTubePlayer = {exports: {}};

exports.YouTubePlayer = YouTubePlayer;
